// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as Cookie from 'app/packages/cookie-utils';
import canUseHistory from 'app/common/lib/util/canUseHistory';
import changeWindowLocation from 'app/common/lib/util/changeWindowLocation';
import CloseupLoader from 'app/common/react/components/growth/unauth/open/closeup/Closeup/CloseupLoader';
import CONTAINER_NAME from 'app/common/react/components/growth/unauth/lib/loggingContainerConstants';
import ContentHeaderProvider from 'app/common/react/ui/ContentHeaderContext';
import DefaultCSS from 'app/common/react/components/growth/unauth/DefaultCSS';
import ErrorModal from 'app/common/react/components/growth/unauth/ErrorModal/ErrorModal';
import FullPageModalCSS from 'app/common/react/components/growth/unauth/FullPageModal/FullPageModalCSS';
import FullPageModalLoader from 'app/common/react/components/growth/unauth/FullPageModal/FullPageModalLoader';
import FullPageResponse from 'app/common/react/components/growth/unauth/signup/FullPageResponse/FullPageResponse';
import FullPageSignupLoader from 'app/common/react/components/growth/unauth/signup/FullPageSignup/FullPageSignupLoader';
import getHybridClickthroughUpsell from 'app/common/react/components/growth/unauth/open/hybrid/clickthroughUtils';
import GoogleOneTapPresenterLoader from 'app/common/react/components/growth/unauth/signup/GoogleOneTap/GoogleOneTapPresenterLoader';
import HeaderCSS from 'app/common/react/components/growth/unauth/header/HeaderCSS';
import HeaderHeightProvider from 'app/common/react/components/Header/Context/ContextProvider';
import InlineStyle from 'app/common/react/components/InlineStyle';
import OpenPrivacyLink from 'app/common/react/components/growth/unauth/open/OpenPrivacyLink';
import PageController from 'app/common/react/components/growth/unauth/PageController';
import PropTypes from 'prop-types';
import ResetCSS from 'app/common/react/components/growth/unauth/ResetCSS';
import SearchBox from 'app/common/react/components/growth/unauth/open/search/SearchBox/SearchBox';
import SearchBoxWrapper from 'app/common/react/components/growth/unauth/open/search/SearchBoxWrapper';
import SignupCSS from 'app/common/react/components/growth/unauth/signup/SignupCSS';
import SignupWelcomeLoading from 'app/common/react/components/growth/unauth/signup/SignupWelcomeLoading/SignupWelcomeLoading';
import TextInputFieldCSS from 'app/common/react/components/growth/unauth/signup/TextInputField/TextInputFieldCSS';
import throttle from 'lodash/throttle';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import type { SignupCredentialsAndLoggingData } from 'app/packages/pinterest-flow-types/registration';
import type { State as ReduxState } from 'app/www-unauth/redux/reducers/types';
import UNAUTH_PAGE_TYPE from 'app/common/react/components/growth/unauth/lib/UnauthPageType';
import UnauthHeader from 'app/common/react/components/growth/unauth/header/UnauthHeader/UnauthHeader';
import UnauthHybridBanner from 'app/common/react/components/growth/unauth/open/UnauthHybridBanner';
import UnauthPageWrapperContext from 'app/www-unauth/components/UnauthPageWrapper/UnauthPageWrapperContext';
import UnauthUsage from 'app/common/lib/UnauthUsage';
import urlUtil from 'app/common/lib/urlUtil';
import { Box } from 'gestalt';
import { compose } from 'redux';
import { FullPageSignupToggleType } from 'app/common/react/components/growth/unauth/signup/FullPageSignup/FullPageSignupToggleType';
import { GRID_ITEM_WIDTH } from 'app/common/lib/react/gridUtils';
import { HybridTiers } from 'app/common/react/components/growth/unauth/open/hybrid/hybridConstants';
import { INVITE_OBJECT_STATE } from 'app/www-unauth/redux/reducers/inviteObject';
import { isAutoLoginDisabled } from 'app/packages/pinterest-authentication/utils';
import { isUrlInGuidePageExperience } from 'app/common/react/components/growth/unauth/UnauthGuidePage/GuidePageUtils';
import { MODAL_BEHAVIOR } from 'app/common/react/components/growth/unauth/open/closeup/CloseupContent/HybridCloseupBanner';
import { ModalType } from 'app/common/react/components/growth/unauth/FullPageModal/FullPageModal';
import { parseQuery } from 'app/packages/url';
import { SingleTreatmentExp } from 'app/common/lib/experiment';
import { UNAUTH_ACTION_TYPE } from 'app/www-unauth/redux/reducers/modalBudget';
import getBannerInfo, {
  isInLoginSignupModalCooldown,
} from 'app/common/react/components/growth/unauth/open/hybrid/closeupBannerUtils';
import type {
  CloseupPin,
  GridPin,
  Pin as PinFlowType,
} from 'app/packages/pinterest-flow-types/pin';
import type {
  FacebookUserData,
  LoginCreds,
  UnauthUserInfo,
} from 'app/packages/pinterest-flow-types/authentication';
import type {
  GenericAuthenticationCredsType,
  SignupMethodType,
} from 'app/packages/pinterest-authentication/registration';
import withSeoExperiments, { type SeoExperiments } from 'app/common/lib/react/withSeoExperiments';
import withUnauthSeoExperiments, {
  type UnauthSeoExperiments,
} from 'app/common/lib/react/withUnauthSeoExperiments';
import {
  inOpenModalExperience,
  modalBudgetForUser,
  setCookieHasSeenLoginModal,
  setUserInModalBudgetSystem,
  userInModalBudgetSystem,
  setUserSessionOpenUnauth,
} from 'app/common/react/components/growth/unauth/open/hybrid/hybridExperimentUtils';
import {
  SignupSource,
  type SignupSourceType,
  SignupTypes,
  type SignupTypesFlowType,
} from 'app/common/react/components/growth/unauth/signup/constants';
import {
  withRequestContext,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';

type Props = {
  children: React.Node,
  clickthroughCount: number,
  closeupCount: number,
  // $FlowFixMe: Please add "import type { Dispatch } from 'redux';"
  dispatch: Dispatch<any>,
  facebookAutoLoginStatus: string,
  hybridTier: string,
  inviteObject: Object,
  isShowEUCookieBar: boolean,
  pageType: string,
  requestContext: RequestContextType,
  scrollCount: number,
  seoUnauthExperiments: UnauthSeoExperiments,
  seoExperiments: SeoExperiments,
  viewData: Object,
  pinCategory?: string,
};

type State = {
  showCloseupModal: boolean,
  showSignupModal: boolean,
  showHybridBannerModal: boolean,
  email: string,
  emailValidationError: string,
  passwordValidationError: string,
  googleOneTapFailedToShow: ?boolean,
  canCloseSignupModal: boolean,
  mfaCreds: ?LoginCreds,
  modalType: string,
  hasCompleteCloseupPinData: boolean,
  hasSeenScrollModal: boolean,
  // $FlowFixMe Flow v0.104.0 upgrade supression.
  closeupModalPin: *,
  signupSource: ?SignupSourceType,
  container: string,
  authenticationCredentials: ?GenericAuthenticationCredsType,
  userInfo: ?UnauthUserInfo,
  showFinalBudgetedSignupModal: boolean,
  showSignupWelcomeLoading: boolean,
  showResponseModal: boolean,
  responseType: string,
  responseModalPin: ?PinFlowType,
  refreshingPage: boolean,
  isResponseSignup: boolean,
  hasUserScroll: boolean,
  skipModal: boolean,
};

type SignupModalInfo = { d?: string, mt?: string };

export const cssStyles = (isTablet: boolean) =>
  ResetCSS() +
  DefaultCSS() +
  FullPageModalCSS() +
  SignupCSS(false) +
  HeaderCSS(isTablet, true, GRID_ITEM_WIDTH) +
  TextInputFieldCSS();

const signupWelcomeLoadingOverlayStyle = {
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  opacity: 1,
  position: 'fixed',
  top: '0px',
  bottom: '0px',
  left: '0px',
  right: '0px',
  zIndex: 1000,
};

const modalBudgetLimit = {
  [HybridTiers.tier1]: 10,
  [HybridTiers.tier2]: 3,
  [HybridTiers.tier3]: 2,
};
const FIRST_CLICKTHROUGH_BUDGET_VALUE = 1;
const SECOND_CLICKTHROUGH_BUDGET_VALUE = 10;
const CLICKTHROUGH_DEFAULT_BUDGET_VALUE = 2;

const FIRST_CLOSEUP_BUDGET_VALUE = 12;
const CLOSEUP_DEFAULT_BUDGET_VALUE = 2;

const SCROLL_THRESHOLD_BUDGET_VALUE = 15;

// Pages which should not render the hybrid banner
const HYBRID_BANNER_BLACKLIST_PAGES = ['passwordReset', 'passwordUserName', 'topic', 'flashlight'];
const GOOGLE_ONE_TAP_BLACKLIST_PAGES = ['passwordReset', 'passwordUserName', 'topic'];

export class UnauthPageWrapper extends React.Component<Props, State> {
  static defaultProps = { hybridTier: '' };

  constructor(props: Props) {
    super(props);
    this.state = {
      showCloseupModal: false,
      showSignupModal: false,
      showHybridBannerModal: false,
      showFinalBudgetedSignupModal: false,
      email: '',
      emailValidationError: '',
      passwordValidationError: '',
      canCloseSignupModal: true,
      googleOneTapFailedToShow: undefined,
      mfaCreds: undefined,
      modalType: SignupTypes.signup,
      hasCompleteCloseupPinData: false,
      closeupModalPin: undefined,
      signupSource: undefined,
      container: '',
      authenticationCredentials: null,
      userInfo: null,
      showSignupWelcomeLoading: false,
      showResponseModal: false,
      responseType: '',
      responseModalPin: null,
      refreshingPage: false,
      isResponseSignup: true,
      hasSeenScrollModal: false,
      hasUserScroll: false,
      skipModal: false,
    };
  }

  componentDidMount() {
    trackRegisterAction(
      `unauth_web.unauth_page_wrapper.${this.props.pageType}.mounted.is_mobile_false`,
    );

    if (this.unauthBudgetExpGroup().startsWith('enabled')) {
      setUserInModalBudgetSystem(true);
    }

    this.mounted = true;

    const expGroup =
      this.props.seoUnauthExperiments.v2ActivateExperiment('unauth_web_page_wrapper_optimize_2') ||
      '';
    if (
      expGroup.startsWith('enabled_load_secondary_content_after_user_scroll') ||
      expGroup.startsWith('enabled_scroll_and_prevent_google_one_tap_error_refresh')
    ) {
      window.addEventListener('scroll', this.handleScroll);
    }
    const isOpenExperience = parseQuery(window.location.search).utm_source === 'p100'; // for pinterest 100 trend report microsite incoming links
    if (isOpenExperience) {
      setUserSessionOpenUnauth();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = throttle((evt: SyntheticEvent<Document>) => {
    if (!this.state.hasUserScroll) {
      this.setState({ hasUserScroll: true });
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, 1000);

  componentDidUpdate = (prevProps: Props, prevState: State) => {
    this.updateModalBudget(prevProps, prevState);
  };

  mounted = false;

  unauthBudgetExpGroup = () =>
    this.props.seoUnauthExperiments.v2ActivateExperiment('web_unauth_modal_budget_v0') || '';

  updateModalBudget = (prevProps: Props, prevState: State) => {
    // update unauth modal budget, and show a conversion modal if needed
    const { clickthroughCount, closeupCount, hybridTier, scrollCount } = this.props;
    const { hasSeenScrollModal, refreshingPage, showSignupModal } = this.state;

    const limit = modalBudgetLimit[hybridTier];

    let modalBudget = modalBudgetForUser();

    // Due to new behavior of opening closeup in new tab, default
    // to CLOSEUP container here
    let container = CONTAINER_NAME.CLOSEUP;
    let dismissible = true;
    let setCookieCooldown = false;

    if (clickthroughCount === prevProps.clickthroughCount + 1) {
      if (clickthroughCount === 1) {
        modalBudget += FIRST_CLICKTHROUGH_BUDGET_VALUE;
      } else if (clickthroughCount === 2) {
        modalBudget += SECOND_CLICKTHROUGH_BUDGET_VALUE;
      } else {
        modalBudget += CLICKTHROUGH_DEFAULT_BUDGET_VALUE;
      }
      container = CONTAINER_NAME.HYBRID_CLICKTHROUGH;
    }

    const currentCloseupCount = UnauthUsage.getUnauthCloseupCount();
    if (
      closeupCount === prevProps.closeupCount + 1 &&
      !Cookie.get(PCONST.LOCALSTORAGE_HAS_BEEN_SHOWN_LOGIN_MODAL_IN_OPEN)
    ) {
      if (closeupCount === 1 && currentCloseupCount === 1) {
        modalBudget += FIRST_CLOSEUP_BUDGET_VALUE;
      } else {
        modalBudget += CLOSEUP_DEFAULT_BUDGET_VALUE;
      }
      setCookieCooldown = true;
    }

    if (scrollCount === prevProps.scrollCount + 1 && !isInLoginSignupModalCooldown()) {
      if (this.unauthBudgetExpGroup() === 'enabled_extra_scroll') {
        if (scrollCount === 4 && !hasSeenScrollModal) {
          modalBudget += SCROLL_THRESHOLD_BUDGET_VALUE;
        }
      } else if (scrollCount === 3 && !hasSeenScrollModal) {
        modalBudget += SCROLL_THRESHOLD_BUDGET_VALUE;
      }
      container = CONTAINER_NAME.INSPIRED_BANNER;
      dismissible = this.inOpenOrTierOne();
      setCookieCooldown = true;
    }

    if (
      modalBudget >= limit &&
      !showSignupModal &&
      userInModalBudgetSystem() &&
      !inOpenModalExperience(true) &&
      !refreshingPage
    ) {
      if (currentCloseupCount > 1 || clickthroughCount > 0) {
        dismissible = this.inOpenOrTierOne();
      }
      const modalType = this.inOpenOrTierOne() ? SignupTypes.login : SignupTypes.signup;
      this.setState({
        canCloseSignupModal: dismissible,
        container,
        modalType,
        showSignupModal: true,
      });
      if (container === CONTAINER_NAME.INSPIRED_BANNER) {
        this.setState({ hasSeenScrollModal: true });
      }
      trackRegisterAction(`unauth_web_container.${container}.${hybridTier}.${modalType}.shown`);

      if (setCookieCooldown) {
        setCookieHasSeenLoginModal();
      }
    }

    modalBudgetForUser(modalBudget);
  };

  handleCloseupModalHide = () => {
    this.setState({
      closeupModalPin: null,
      hasCompleteCloseupPinData: false,
      showCloseupModal: false,
    });
  };

  handleSignupModalHide = () => {
    this.props.dispatch({
      type: UNAUTH_ACTION_TYPE.DISMISS_MODAL,
    });
    this.setState({
      email: '',
      emailValidationError: '',
      passwordValidationError: '',
      showSignupModal: false,
      canCloseSignupModal: true,
    });
    modalBudgetForUser(0);
  };

  handleShowHybridBannerModal = (shown: boolean) => {
    if (shown) {
      this.setState({ showHybridBannerModal: true });
    } else {
      this.setState({ showHybridBannerModal: false });

      this.props.dispatch({ type: UNAUTH_ACTION_TYPE.DISMISS_MODAL });
      modalBudgetForUser(0);

      trackRegisterAction('unauth.web.dismiss_modal_via_scroll');
    }
  };

  handleLoginError = (
    error: { type: string, formattedError: string, message: string },
    email: string,
  ) => {
    this.setState({ email });

    if (!error) {
      this.showSignupModal(SignupTypes.login, SignupSource.login); // Default to login
      return;
    }

    if (error.type === 'email') {
      // failed input validation
      this.setState({ emailValidationError: error.message });
      this.showSignupModal(SignupTypes.login, SignupSource.login);
    } else if (error.type === 'password') {
      // failed input validation
      this.setState({ passwordValidationError: error.message });
      this.showSignupModal(SignupTypes.login, SignupSource.login);
    } else if (error.type === 'login') {
      // failed login request
      if (error.formattedError === 'invalidEmail') {
        this.setState({ emailValidationError: error.message });
        this.showSignupModal(SignupTypes.signup, SignupSource.defaultSource);
      } else {
        this.setState({ passwordValidationError: error.message });
        this.showSignupModal(SignupTypes.login, SignupSource.login);
      }
    }
  };

  showSignupModal = (
    type: SignupTypesFlowType,
    signupSource: SignupSourceType,
    container?: string,
    e?: SyntheticEvent<>,
  ) => {
    this.setState({
      showSignupModal: true,
      modalType: type,
      signupSource,
      container,
    });

    const hybridTier = this.props.hybridTier;
    const containerName = typeof container !== 'string' ? 'undefined' : container;
    trackRegisterAction(`unauth_web_container.${containerName}.${hybridTier}.${type}.shown`);
    if (e) {
      e.preventDefault();
    }
  };

  showSignupLoginModal = (type: SignupTypesFlowType, dismissible: boolean) => {
    this.setState({
      modalType: type,
      showSignupModal: true,
      canCloseSignupModal: dismissible,
      container: CONTAINER_NAME.CLOSEUP,
      showFinalBudgetedSignupModal: !dismissible,
    });
    const hybridTier = this.props.hybridTier;
    trackRegisterAction(
      `unauth_web_container.${CONTAINER_NAME.CLOSEUP}.${hybridTier}.${type}.shown`,
    );
  };

  showLoginModal = (container: string) => {
    this.setState({ showSignupModal: true, modalType: 'login', container });
    const hybridTier = this.props.hybridTier;
    const containerName = typeof container !== 'string' ? 'undefined' : container;
    trackRegisterAction(`unauth_web_container.${containerName}.${hybridTier}.login.shown`);
  };

  showSocialConnectExtraInfoCollection = (modalType: SignupTypesFlowType) => (
    network: SignupMethodType,
    userData: FacebookUserData | {},
    credentialsAndLoggingData: SignupCredentialsAndLoggingData,
  ) => {
    this.setState({
      showSignupModal: true,
      modalType,
      authenticationCredentials: {
        type: network,
        credentialsAndLoggingData,
        userData,
      },
    });
  };

  showResponseMessageModal = (isSignup: boolean) => {
    this.setState({
      showSignupModal: false,
      showResponseModal: true,
      isResponseSignup: isSignup,
    });
  };

  // $FlowFixMe Flow v0.104.0 upgrade supression.
  showResponseModalSignup = (responseType: string, responseModalPin: *) => {
    this.setState({
      responseType,
      responseModalPin,
    });
    this.showSignupModal(
      SignupTypes.respondMessage,
      SignupSource.defaultSource,
      CONTAINER_NAME.RESPONSE_FLYOUT,
    );
  };

  openInPlp = (pin: GridPin, signupModalInfo: SignupModalInfo) => {
    let path = '/pin/' + pin.id + '/';
    if (signupModalInfo) {
      path = urlUtil.appendQueryString(path, signupModalInfo);
    }
    this.setState({
      refreshingPage: true,
    });
    changeWindowLocation(path, false);
  };

  getSignupModalInfo = () => {
    const hybridTier = this.props.hybridTier;
    const bannerInfo = getBannerInfo(
      hybridTier,
      UnauthUsage.getUnauthCloseupCount(),
      this.props.seoUnauthExperiments,
    );

    const { modalBehavior, modalType } = bannerInfo;

    // most of this logic is lifted from the render() method of HybridCloseupBanner.js
    if (!inOpenModalExperience()) {
      // deal with the first click
      if (!Cookie.get(PCONST.LOCALSTORAGE_HAS_BEEN_SHOWN_LOGIN_MODAL_IN_OPEN)) {
        setCookieHasSeenLoginModal();

        const isPinPage = this.props.pageType === UNAUTH_PAGE_TYPE.PIN;
        const modalType = isPinPage && !this.inOpenOrTierOne() ? 'signup' : 'login';

        return { d: 't', mt: modalType };
      }

      // all subsequent clicks
      if (
        modalBehavior &&
        modalType &&
        (modalBehavior === MODAL_BEHAVIOR.BLOCKING || !isInLoginSignupModalCooldown())
      ) {
        const dismissible = modalBehavior === MODAL_BEHAVIOR.DISMISSIBLE ? 't' : 'f';
        return { d: dismissible, mt: modalType };
      }
    }

    return {};
  };

  pinImageClickHandler = (
    event: SyntheticEvent<>,
    pin: GridPin,
    openPlpInSameTab?: boolean = false,
    skipModal?: boolean = false,
  ) => {
    event.preventDefault();
    trackRegisterAction(`unauth.desktop.${this.props.pageType}.pin_image.click`);

    this.props.dispatch({
      type: UNAUTH_ACTION_TYPE.CLOSEUP,
    });

    if (openPlpInSameTab) {
      const signupModalInfo = this.getSignupModalInfo();
      this.openInPlp(pin, signupModalInfo);
      return;
    }

    this.setState({
      closeupModalPin: pin,
      showSignupModal: false,
      canCloseSignupModal: true,
      showCloseupModal: true,
      hasCompleteCloseupPinData: false,
      skipModal,
    });

    const mainPinClickExpGroup =
      this.props.requestContext.experiments.v2ActivateExperiment(
        'unauth_desktop_main_pin_click_v0',
      ) || '';

    if (
      mainPinClickExpGroup.startsWith('enabled_closeup_no_first_modal') &&
      UnauthUsage.getUnauthClickthroughCount() === 0
    ) {
      setCookieHasSeenLoginModal();
    }

    // TODO cyao: iterate on pinPage check
    if (
      !Cookie.get(PCONST.LOCALSTORAGE_HAS_BEEN_SHOWN_LOGIN_MODAL_IN_OPEN) &&
      !inOpenModalExperience()
    ) {
      setCookieHasSeenLoginModal();

      if (skipModal) {
        return;
      }

      const isPinPage = this.props.pageType === UNAUTH_PAGE_TYPE.PIN;
      const modalType = isPinPage && !this.inOpenOrTierOne() ? 'signup' : 'login';
      this.setState({
        showSignupModal: true,
        modalType,
      });

      if (isPinPage) {
        this.setState({ container: CONTAINER_NAME.PIN_IMAGE });
      }
      trackRegisterAction(
        `unauth_web_container.${CONTAINER_NAME.CLOSEUP}.${
          this.props.hybridTier
        }.${modalType}.shown`,
      );
    }
  };

  inOpenOrTierOne = () =>
    !(this.props.hybridTier === HybridTiers.tier2 || this.props.hybridTier === HybridTiers.tier3);

  handleFailureToShow = () => {
    const expGroup =
      this.props.seoUnauthExperiments.v2ActivateExperiment('unauth_web_page_wrapper_optimize_2') ||
      '';

    if (
      !expGroup.startsWith('enabled_prevent_one_tap_page_refresh') &&
      !expGroup.startsWith('enabled_scroll_and_prevent_google_one_tap_error_refresh') &&
      !expGroup.startsWith('enabled_fb_and_prevent_google_one_tap_error_refresh')
    ) {
      this.setState({
        googleOneTapFailedToShow: true,
      });
    }
  };

  hybridClickthroughHandler = () => {
    this.props.dispatch({
      type: UNAUTH_ACTION_TYPE.CLICKTHROUGH,
    });
    UnauthUsage.logUnauthHybridClickthrough();

    if (inOpenModalExperience()) {
      return;
    }

    const upsellType = getHybridClickthroughUpsell(this.props.hybridTier);

    const canCloseSignupModal = this.inOpenOrTierOne();
    this.setState({ canCloseSignupModal });

    if (upsellType === SignupTypes.login) {
      this.showLoginModal(CONTAINER_NAME.HYBRID_CLICKTHROUGH);
    } else if (
      upsellType === SignupTypes.signup ||
      upsellType === SignupTypes.signupOrPersonalizedLogin
    ) {
      this.showSignupModal(
        upsellType,
        SignupSource.defaultSource,
        CONTAINER_NAME.HYBRID_CLICKTHROUGH,
      );
    }
  };

  handleCloseClick = () => {
    trackRegisterAction('unauth.web.page_wrapper.handle_close_click');
    this.setState({ showSignupModal: false });
  };

  showDelayedContent = () => {
    const expGroup =
      this.props.seoUnauthExperiments.v2ActivateExperiment('unauth_web_page_wrapper_optimize_2') ||
      '';
    if (
      expGroup.startsWith('enabled_load_secondary_content_after_fb_success') ||
      expGroup.startsWith('enabled_fb_and_prevent_google_one_tap_error_refresh')
    ) {
      return this.props.facebookAutoLoginStatus !== 'null' || isAutoLoginDisabled();
    } else if (
      expGroup.startsWith('enabled_load_secondary_content_after_user_scroll') ||
      expGroup.startsWith('enabled_scroll_and_prevent_google_one_tap_error_refresh')
    ) {
      return this.state.hasUserScroll;
    }
    return true;
  };

  // Callback to update the Closeup detailed pin data from PinResource call
  // If closeup has been closed within this time, do not update
  updateCloseupModalPinState = (pin: CloseupPin) => {
    if (!this.mounted) {
      return;
    }

    if (this.state.closeupModalPin) {
      this.setState({
        closeupModalPin: pin,
        hasCompleteCloseupPinData: true,
      });
    }
  };

  // returns null if there is no invite
  getInviteSender = (inviteObject: Object) => {
    const invite =
      inviteObject && inviteObject.loadedState === INVITE_OBJECT_STATE.loaded
        ? inviteObject.invite
        : null;
    return invite ? invite.sender : null;
  };

  logLoginSignupModalView = () => {
    const isPinPage = this.props.pageType === UNAUTH_PAGE_TYPE.PIN;
    const isBoardPage = this.props.pageType === UNAUTH_PAGE_TYPE.BOARD;
    if (isPinPage || isBoardPage) {
      UnauthUsage.logLoginSignupModalView();
    }
  };

  renderCloseup = (scrollContainer: ?HTMLElement, onCloseClick: () => void) => {
    const useNavigationHistory = canUseHistory();

    const hybridClickthroughHandler = this.props.hybridTier ? this.hybridClickthroughHandler : null;

    return (
      <CloseupLoader
        forceUpdatePinData
        onCloseClick={onCloseClick}
        pageSize={25}
        pin={this.state.closeupModalPin}
        pinImageClickHandler={this.pinImageClickHandler}
        hideMetaForSignupModal={
          this.state.showFinalBudgetedSignupModal &&
          (
            this.props.seoUnauthExperiments.v2ActivateExperiment('unauth_web_final_modal') || ''
          ).startsWith('enabled')
        }
        hybridClickthroughHandler={hybridClickthroughHandler}
        hybridTier={this.props.hybridTier}
        pinResourceDelegate={this.updateCloseupModalPinState}
        hasCompletePinData={this.state.hasCompleteCloseupPinData}
        scrollContainer={scrollContainer}
        showRelatedPinsInSideGrid
        showSignupLoginModal={this.showSignupLoginModal}
        showSignupModal={(event) =>
          this.showSignupModal(
            SignupTypes.signup,
            SignupSource.saveButton,
            CONTAINER_NAME.CLOSEUP,
            event,
          )
        }
        onLoginClick={(event) =>
          this.showSignupModal(
            SignupTypes.login,
            SignupSource.login,
            CONTAINER_NAME.CLOSEUP_BANNER,
            event,
          )
        }
        onSignupClick={(event) =>
          this.showSignupModal(
            SignupTypes.signup,
            SignupSource.defaultSource,
            CONTAINER_NAME.CLOSEUP_BANNER,
            event,
          )
        }
        useNavigationHistory={useNavigationHistory}
      />
    );
  };

  // Do not present Closeup Modal with canClose if final budgeted signup modal is presented
  renderCloseupModal = () => (
    <FullPageModalLoader
      canClose={this.state.skipModal || !this.state.showFinalBudgetedSignupModal}
      hybridTier={this.props.hybridTier}
      onHide={this.handleCloseupModalHide}
      renderContent={this.renderCloseup}
      type={ModalType.CLOSEUP}
    />
  );

  // TODO cyao: iterate on pinPage check
  renderFullPageSignup = () => {
    const {
      authenticationCredentials,
      email,
      emailValidationError,
      mfaCreds,
      passwordValidationError,
    } = this.state;

    const toggleType = this.state.canCloseSignupModal
      ? FullPageSignupToggleType.NOT_NOW_BUTTON
      : FullPageSignupToggleType.DEFAULT_TOGGLE;

    const isPinPage = this.props.pageType === UNAUTH_PAGE_TYPE.PIN;
    const isBoardPage = this.props.pageType === UNAUTH_PAGE_TYPE.BOARD;
    this.logLoginSignupModalView();

    const inviter = this.getInviteSender(this.props.inviteObject);

    return (
      <FullPageSignupLoader
        container={this.state.container}
        email={email}
        emailValidationError={emailValidationError}
        hybridTier={this.props.hybridTier}
        mfaCreds={mfaCreds}
        handleCloseClick={
          isPinPage || isBoardPage ? this.handleCloseClick : this.handleSignupModalHide
        }
        handleShowingSignupWelcomeLoading={(shouldShow) => {
          this.setState({
            showSignupWelcomeLoading: shouldShow,
          });
        }}
        passwordValidationError={passwordValidationError}
        signupSource={this.state.signupSource}
        socialRegistrationCredentials={authenticationCredentials}
        type={this.state.modalType}
        pageType={this.props.pageType}
        toggleType={toggleType}
        userInfo={this.state.userInfo}
        inviter={inviter}
        showResponseMessageModal={this.showResponseMessageModal}
        pinCategory={this.props.pinCategory}
      />
    );
  };

  renderSignupModal = () => {
    const inviter = this.getInviteSender(this.props.inviteObject);

    if (this.state.skipModal) {
      this.logLoginSignupModalView();
      return null;
    }

    return (
      <Box data-test-id="fullPageSignupModal">
        <FullPageModalLoader
          hybridTier={this.props.hybridTier}
          canClose={this.state.canCloseSignupModal}
          onCloseClick={this.handleSignupModalHide}
          renderContent={this.renderFullPageSignup}
          type={ModalType.DEFAULT}
          inviter={inviter}
        />
      </Box>
    );
  };

  // TODO cyao: iterate on pin/board page check
  renderHeader = () => {
    const isPinPage = this.props.pageType === UNAUTH_PAGE_TYPE.PIN;
    const isBoardPage = this.props.pageType === UNAUTH_PAGE_TYPE.BOARD;
    const inNoLazyLoadSearchWrapper = new SingleTreatmentExp(
      this.props.requestContext,
      'unauth_web_no_async_load_search',
    ).enabled();
    const searchBox = inNoLazyLoadSearchWrapper ? (
      <SearchBox id="mainSearchTextbox" />
    ) : (
      <SearchBoxWrapper id="mainSearchTextbox" />
    );
    return (
      <UnauthHeader
        alignHeader
        container={this.props.pageType}
        dispatch={this.props.dispatch}
        hybridTier={this.props.hybridTier}
        handleLoginError={this.handleLoginError}
        onLoginClick={(event) => {
          this.showSignupModal(
            SignupTypes.login,
            SignupSource.login,
            CONTAINER_NAME.UNAUTH_HEADER,
            event,
          );
        }}
        onSignupClick={(event) => {
          this.showSignupModal(
            SignupTypes.signup,
            SignupSource.defaultSource,
            CONTAINER_NAME.UNAUTH_HEADER,
            event,
          );
        }}
        stickyHeader={!(isPinPage || isBoardPage)}
        isShowEUCookieBar={this.props.isShowEUCookieBar}
      >
        {searchBox}
      </UnauthHeader>
    );
  };

  renderResponseModal = () => (
    <Box data-test-id="fullPageResponseModal">
      <FullPageModalLoader
        hybridTier={this.props.hybridTier}
        canClose={false}
        renderContent={this.renderFullPageResponseModal}
        type={ModalType.DEFAULT}
      />
    </Box>
  );

  renderFullPageResponseModal = () => {
    const invite =
      this.props.inviteObject.loadedState === INVITE_OBJECT_STATE.loaded
        ? this.props.inviteObject.invite
        : null;
    const { responseModalPin, isResponseSignup, responseType } = this.state;

    return (
      responseModalPin &&
      invite && (
        <FullPageResponse
          sender={invite.sender}
          pin={responseModalPin}
          isResponseSignup={isResponseSignup}
          responseType={responseType}
        />
      )
    );
  };

  render() {
    const { showSignupWelcomeLoading } = this.state;
    const { children, hybridTier, pageType, seoUnauthExperiments, viewData } = this.props;
    const { currentUrl, locale } = this.context;

    const enabledHybridBanner =
      !__SERVER__ &&
      !HYBRID_BANNER_BLACKLIST_PAGES.includes(pageType) &&
      !isUrlInGuidePageExperience(pageType, currentUrl, locale, seoUnauthExperiments);
    const enabledGoogleOneTap = !__SERVER__ && !GOOGLE_ONE_TAP_BLACKLIST_PAGES.includes(pageType);
    return (
      <Box>
        {this.state.showCloseupModal || this.state.showSignupModal ? (
          <InlineStyle unsafeCSS="body { overflow: hidden !important }" />
        ) : null}
        <InlineStyle unsafeCSS={cssStyles(false)} />
        <UnauthPageWrapperContext.Provider
          value={{
            pinLinkClickHandler: this.hybridClickthroughHandler,
            pinImageClickHandler: this.pinImageClickHandler,
            showSignupModal: this.showSignupModal,
            showSignupLoginModal: this.showSignupLoginModal,
            showResponseModalSignup: this.showResponseModalSignup,
            modalOpened: this.state.showSignupModal || this.state.showHybridBannerModal,
          }}
        >
          <ContentHeaderProvider>
            <HeaderHeightProvider>
              <PageController hybridTier={hybridTier} page={pageType} viewData={viewData}>
                {children}
                {this.renderHeader()}
                {hybridTier && enabledHybridBanner && this.showDelayedContent() ? (
                  <UnauthHybridBanner
                    marketTier={hybridTier}
                    onHybridBannerTriggerFullscreen={this.handleShowHybridBannerModal}
                    onSignupClick={() => {
                      this.showSignupModal(
                        SignupTypes.signup,
                        SignupSource.defaultSource,
                        CONTAINER_NAME.HYBRID_BANNER,
                      );
                    }}
                    onLoginClick={() => {
                      this.showSignupModal(
                        SignupTypes.login,
                        SignupSource.login,
                        CONTAINER_NAME.HYBRID_BANNER,
                      );
                    }}
                    inviteObject={this.props.inviteObject}
                  />
                ) : null}
                {this.state.showCloseupModal ? this.renderCloseupModal() : null}
                {this.state.showSignupModal ? this.renderSignupModal() : null}
                {this.state.showResponseModal ? this.renderResponseModal() : null}
                <OpenPrivacyLink hasBanner={enabledHybridBanner} />
                {showSignupWelcomeLoading && (
                  <div style={signupWelcomeLoadingOverlayStyle}>
                    <SignupWelcomeLoading />
                  </div>
                )}
                {!showSignupWelcomeLoading &&
                  enabledGoogleOneTap && (
                    <React.Fragment>
                      {enabledGoogleOneTap ? this.renderGoogleOneTap() : undefined}
                      <ErrorModal />
                    </React.Fragment>
                  )}
              </PageController>
            </HeaderHeightProvider>
          </ContentHeaderProvider>
        </UnauthPageWrapperContext.Provider>
      </Box>
    );
  }

  renderGoogleOneTap = () => {
    const { pageType } = this.props;
    return (
      <GoogleOneTapPresenterLoader
        container={pageType}
        handleFailureToShow={this.handleFailureToShow}
        handleLoginWithMfa={(creds) => {
          this.setState({
            showSignupModal: true,
            modalType: SignupTypes.loginMfa,
            mfaCreds: creds,
          });
        }}
        handleLoginError={() => {
          this.setState({
            email: undefined,
            showSignupModal: true,
            modalType: SignupTypes.login,
            signupSource: SignupSource.login,
          });
        }}
        handleSignupConfirmed={this.showSocialConnectExtraInfoCollection(
          SignupTypes.socialSignupWithAge,
        )}
        handleSignupError={() => {
          this.setState({
            showSignupModal: true,
            modalType: SignupTypes.signup,
            signupSource: SignupSource.defaultSource,
          });
        }}
        handleShowLogin={() => {
          this.showSignupModal(
            SignupTypes.login,
            SignupSource.login,
            CONTAINER_NAME.GOOGLE_ONE_TAP,
          );
        }}
        showRegisterLoadingScreen={() =>
          this.setState({
            showSignupWelcomeLoading: true,
          })
        }
      />
    );
  };
}

UnauthPageWrapper.contextTypes = {
  currentUrl: PropTypes.string,
  isBot: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  isFromNavigate: PropTypes.bool.isRequired,
};

const mapStateToProps = (state: ReduxState) => ({
  clickthroughCount: state.modalBudget.clickthroughCount,
  closeupCount: state.modalBudget.closeupCount,
  facebookAutoLoginStatus: state.facebookAutoLogin.facebookAutoLoginStatus,
  inviteObject: state.inviteObject,
  scrollCount: state.modalBudget.scrollCount,
  isShowEUCookieBar: state.euCookieBar.isShowEUCookieBar,
});

export default compose(
  withRequestContext,
  connect(mapStateToProps),
  withUnauthSeoExperiments,
  withSeoExperiments,
)(UnauthPageWrapper);
